
module.directive('enrollmentDetailsForm', function($q, ModelService) {
    var fields = ['attendance', 'service_hours'];
    return {
        restrict: 'E',
        templateUrl: 'students/enrollment/enrollmentDetailsForm',
        scope: {enrollment: '=', slotCount: '=', participant: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = ModelService.copyFields(scope.enrollment, fields);
            scope.data.participant_email = scope.participant.participant_email;
            basicForm.data = scope.data;
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return $q.all([
                    ModelService.patchModel(scope.enrollment, data),
                    ModelService.patchModel(scope.participant, data),
                ]);
            };
        },
    };
});
